import React from 'react';
import FormSection from '../../../components/ui/FormSection';
import { ComponentComponentsFormSection } from '../../../types/schema';
import { FormSectionRendererProps } from '../types';

export const FormSectionRenderer: React.FC<FormSectionRendererProps> = ({
  section,
  index,
  answers,
  isWizardMode,
  currentSectionIndex,
  totalSections,
  isSectionComplete,
  onAdvanceSection,
  locale,
  onAnswerChange,
  promptQuestions: promptQuestionsForSection,
  loadingPromptQuestions,
  loadingPromptResult,
  allPromptQuestions,
  loadingPromptSections,
  loadPromptQuestions,
  promptError,
  buttonText,
  questionStartIndex,
  isTestMode,
}) => {
  const isVisible = !isWizardMode || index <= currentSectionIndex;
  const isCurrentSection = isWizardMode && index === currentSectionIndex;
  const sectionComplete = isSectionComplete(
    section,
    answers,
    allPromptQuestions || {},
    loadingPromptSections || {},
  );
  const isLastSection = index === totalSections - 1;
  const showAdvanceButton = isWizardMode && isCurrentSection && !isLastSection && sectionComplete;

  if (!isVisible) return null;

  return (
    <FormSection
      key={section?.title}
      id={section?.id}
      section={section as ComponentComponentsFormSection}
      answers={answers}
      locale={locale}
      isWizardMode={isWizardMode}
      showAdvanceButton={showAdvanceButton}
      onAdvance={onAdvanceSection}
      sectionIndex={index}
      currentSectionIndex={currentSectionIndex}
      isCurrentSection={isCurrentSection}
      updateAnswers={onAnswerChange}
      promptQuestions={promptQuestionsForSection}
      loadingPromptQuestions={loadingPromptQuestions}
      loadingPromptResult={loadingPromptResult}
      loaderText={section?.loaderText}
      loadPromptQuestions={loadPromptQuestions}
      promptError={promptError}
      buttonText={buttonText}
      questionStartIndex={questionStartIndex}
      isTestMode={isTestMode}
    />
  );
};
